import { Button } from '@/components/Button';
import { Text } from '@/components/Text';
import { cn } from '@/utils/cn';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FiLink, FiPlus } from 'react-icons/fi';

interface EmptyLinksStateProps {
  onCreateLink: () => void;
}

export const EmptyLinksState = ({ onCreateLink }: EmptyLinksStateProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-4 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="mb-4 rounded-full bg-blue-100 p-4">
        <FiLink className="size-8 text-linko-light" />
      </div>
      <Text className="mb-2 text-xl font-semibold text-gray-800">
        {t('updateCard:links.no-links')}
      </Text>
      <Text className="mb-4 max-w-md text-base text-gray-600">
        {t('updateCard:links.add_first_link')}
      </Text>

      <div className="mb-6 flex flex-col items-center space-y-4 rounded-lg bg-white p-4 shadow-sm">
        {[1, 2, 3].map(step => (
          <div
            key={step}
            className="flex w-full items-center gap-3 rounded-md bg-gray-50 p-3"
          >
            <div className="flex size-8 min-w-8 items-center justify-center rounded-full bg-blue-100">
              <span className="text-sm font-bold text-linko-light">{step}</span>
            </div>
            <Text className="text-left text-sm text-gray-700">
              {t(`updateCard:links.tutorial.step${step}`)}
            </Text>
          </div>
        ))}
      </div>

      <Button
        onClick={onCreateLink}
        className={cn(
          'flex w-full items-center justify-center gap-2 bg-linko-dark text-white shadow-md sm:w-auto',
          'px-6 py-3',
        )}
      >
        <FiPlus className="size-5" />
        {t('updateCard:links.create')}
      </Button>
    </motion.div>
  );
};
